import "./App.css";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {SideNav} from "./components/SideNav";
import {Dashboard} from "./pages/Dashboard";
import {DepositReview} from "./pages/DepositReview";
import LazyLoadingPage from "./components/LazyLoadingPage";
import ProtectedRoute from './services/ProtectedRoute';
import {Box} from "@mui/material";
import {useGlobalContext} from "./context/GlobalState";
import {useEffect, useState} from "react";
import {Login} from "./pages/Login";
import Grid from '@mui/material/Grid2';
import {AdminPanel} from "./pages/AdminPanel";
import {ManageUsers} from "./pages/ManageUsers";
import {SetPassword} from "./pages/SetPassword";
import {ResetPassword} from "./pages/ResetPassword";
import AlertDialog from './components/AlertDialog';

export default function App() {
    const {
        isLoggedIn,
        checkForToken,
        logout,
        isAlertDialogOpen,
        closeAlertDialog,
        alertDialogText
    } = useGlobalContext();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    // Redirect to login page if not logged in
    useEffect(() => {
        const fetchToken = async () => {
            setLoading(true);
            try {
                const hasToken = await checkForToken();
                if (!isLoggedIn && !hasToken && location.pathname !== '/set-password' && location.pathname !== '/reset-password') {
                    navigate("/");
                }
            } catch (error) {
                console.error("Error fetching token:", error);
                logout();
            } finally {
                setLoading(false);
            }
        };

        fetchToken();
    }, [location.pathname]);

    if (loading) {
        return (
            <LazyLoadingPage/>
        );
    }

    return (
        <>
            <Routes>
                <Route path="/reset-password" element={<ResetPassword/>}/>
                <Route path="/set-password" element={<SetPassword/>}/>
                <Route path="/*" element={<LoginPage isLoggedIn={isLoggedIn}/>}/>
            </Routes>
            <AlertDialog isOpen={isAlertDialogOpen} closeDialog={closeAlertDialog} dialogText={alertDialogText}/>
        </>
    );
}

function LoginPage({isLoggedIn}) {
    if (isLoggedIn) {
        return <AuthenticatedApp/>;
    }
    return <Login/>;
}

function AuthenticatedApp() {
    return (
        <Box sx={{display: "flex"}}>
            <SideNav/>
            <MainContent/>
        </Box>
    );
}

function MainContent() {
    return (
        <Grid
            sx={{
                backgroundColor: "primary.background",
                flexGrow: 1,
                padding: 1,
                minHeight: "100vh",
            }}
        >
            <Routes>
                <Route path="/" element={<Dashboard/>}/>
                <Route path="/deposit-review" element={<DepositReview/>}/>
                <Route element={<ProtectedRoute roles={['admin']}/>}>
                    <Route path="/admin-panel" element={<AdminPanel/>}/>
                    <Route path="/manage-users" element={<ManageUsers/>}/>
                </Route>
            </Routes>
        </Grid>
    );
}